<template>
    <v-col>
        <v-card
            elevation="0"
            width="100%"
            :disabled="isLoading"
            :loading="isLoading"
        >
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" lg="10">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        >
                            Objetivos de este mes
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                            "
                        >
                            <v-icon large> mdi-target </v-icon>
                            Objetivos de este mes
                        </div>
                    </v-col>
                    <v-col
                        cols="12"
                        lg="2"
                        :class="
                            $vuetify.breakpoint.mdAndDown
                                ? 'd-flex justify-center align-center'
                                : 'd-flex justify-end align-center'
                        "
                    >
                        <v-btn
                            small
                            color="orange darken-1"
                            outlined
                            @click="goToCalculadora"
                        >
                            Ir a calculadora
                            <v-icon small right> mdi-calculator</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <!-- <v-divider class="test"></v-divider> -->
            <v-card-text v-if="consec_objetivos.length">
                <v-row
                    justify="space-around my-1"
                    align="center"
                    v-for="(objetivo, index) in consec_objetivos"
                    :key="index"
                >
                    <v-hover v-slot="{ hover }">
                        <v-card
                            class="d-flex pa-2 mx-2"
                            flat
                            width="100%"
                            :elevation="hover ? 12 : 0"
                        >
                            <v-row>
                                <v-col
                                    :align="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'center'
                                            : ''
                                    "
                                    md="3"
                                    cols="12"
                                >
                                    <v-icon
                                        class="mr-2"
                                        large
                                        :color="
                                            getColor(
                                                calculatePercentage(objetivo),
                                                objetivo.objetivo
                                            )
                                        "
                                    >
                                        {{ icons[objetivo.familia] }}
                                    </v-icon>
                                    <small class="pl-md-3 overline">{{
                                        objetivo.familia.replace('_', ' ')
                                    }}</small>
                                </v-col>
                                <v-col md="9" cols="12" class="pt-md-5">
                                    <v-progress-linear
                                        height="20"
                                        disabled
                                        :value="calculatePercentage(objetivo)"
                                        :color="
                                            getColor(
                                                calculatePercentage(objetivo),
                                                objetivo.objetivo
                                            )
                                        "
                                    >
                                        <template v-slot:default="{ value }">
                                            <small
                                                :class="
                                                    value > 60 &&
                                                    objetivo.objetivo == 0
                                                        ? 'font-weight-light white--text'
                                                        : 'font-weight-light'
                                                "
                                                >{{ value.toFixed(2) }}%</small
                                            >
                                        </template>
                                    </v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-hover>
                </v-row>
            </v-card-text>
            <v-card-text
                v-else
                :class="`text-center font-weight-light py-6 ${
                    $vuetify.breakpoint.mdAndDown ? 'overline' : 'text-h5'
                }`"
            >
                Sin objetivos establecidos
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import { mapState } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

export default {
    name: 'DashBoardTopComerciales',

    data: () => ({
        icons: {
            POSPAGO: 'mdi-phone',
            PREPAGO: 'mdi-sim',
            FIJOS_PRO: 'mdi-domain',
            FIJOS_PARTICULAR: 'mdi-phone-classic',
            RENUEVO: 'mdi-autorenew',
            ENERGIA: 'mdi-lightning-bolt-circle',
            DOCTOR_GO: 'mdi-doctor',
            ACCESORIOS: 'mdi-file-cabinet',
            TV: 'mdi-television',
            HOME_GO: 'mdi-home',
        },
    }),
    components: {
        LoadingSkeleton,
    },
    computed: {
        ...mapState('dashboard', {
            consec_objetivos: (state) =>
                state.estadisticaConsecucion.consecucion,
            isLoading: (state) => state.estadisticaConsecucion.isLoading,
        }),
    },
    methods: {
        getColor(ventas, objetivo) {
            if (objetivo == 0) {
                return '#2C3A5C';
            } else {
                if (ventas < 25) return '#F44336';
                else if (ventas < 50) return '#FB8C00';
                else if (ventas < 80) return '#FBC02D';
                else return '#4CAF50';
            }
        },
        goToCalculadora() {
            this.$router.push({ name: 'calculadora' });
        },
        calculatePercentage({ objetivo, consecucion, familia: fam }) {
            if (objetivo == 0) {
                return 100;
            } else {
                return (consecucion / objetivo) * 100;
            }
        },
    },
};
</script>

<style scoped>
h1 {
    text-align: center;
}
</style>